<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  userData: { type: Object, required: true },
  retailersOptions: { type: Array, required: true },
  computedPrivileges: { type: Object, required: true },
  t: { type: Function, required: true },
  i18nScope: { type: String, required: true },
  firstNameIsRequired: { type: Boolean, required: true },
  lastNameIsRequired: { type: Boolean, required: true },
  emailIsRequired: { type: Boolean, required: true }
});

</script>

<template>
  <form @submit.prevent>
    <div class="mb-3">
      <label for="firstName" class="form-label">{{ t(`${i18nScope}.user_details.first_name`) }}</label>
      <input type="text" class="form-control" id="firstName" v-model="userData.firstName" required>
      <div v-if="firstNameIsRequired">
        <small class="text-danger">{{ t(`${i18nScope}.user_details.first_name_required`) }}</small>
      </div>
    </div>
    <div class="mb-3">
      <label for="lastName" class="form-label">{{ t(`${i18nScope}.user_details.last_name`) }}</label>
      <input type="text" class="form-control" id="lastName" v-model="userData.lastName" required>
      <div v-if="lastNameIsRequired">
        <small class="text-danger">{{ t(`${i18nScope}.user_details.last_name_required`) }}</small>
      </div>
    </div>
    <div class="mb-3">
      <label for="email" class="form-label">{{ t(`${i18nScope}.user_details.email`) }}</label>
      <input type="email" class="form-control" id="email" v-model="userData.mail" required>
      <div v-if="emailIsRequired">
        <small class="text-danger">{{ t(`${i18nScope}.user_details.email_required`) }}</small>
      </div>
    </div>
    
    <div class="mb-3 form-check" v-show="computedPrivileges.manageNetworks">
      <input type="checkbox" class="form-check-input" id="manage_networks" v-model="userData.manageNetworks">
      <label class="form-check-label" for="manage_networks">{{ t(`${i18nScope}.columns.manage_networks`) }}</label>
    </div>
    <div class="mb-3 form-check" v-show="computedPrivileges.manageLibraries">
      <input type="checkbox" class="form-check-input" id="manage_libraries" v-model="userData.manageLibraries">
      <label class="form-check-label" for="manage_libraries">{{ t(`${i18nScope}.columns.manage_libraries`) }}</label>
    </div>
    <div class="mb-3 form-check" v-show="computedPrivileges.manageActivateCarts">
      <input type="checkbox" class="form-check-input" id="manage_activate_carts" v-model="userData.manageActivateCarts">
      <label class="form-check-label" for="manage_activate_carts">{{ t(`${i18nScope}.columns.manage_activate_carts`) }}</label>
    </div>
    <div class="mb-3 form-check" v-show="computedPrivileges.manageOrders">
      <input type="checkbox" class="form-check-input" id="manage_orders" v-model="userData.manageOrders">
      <label class="form-check-label" for="manage_orders">{{ t(`${i18nScope}.columns.manage_orders`) }}</label>
    </div>
    <div class="mb-3 form-check" v-show="computedPrivileges.manageCuration">
      <input type="checkbox" class="form-check-input" id="manage_curation" v-model="userData.manageCuration">
      <label class="form-check-label" for="manage_curation">{{ t(`${i18nScope}.columns.manage_curation`) }}</label>
    </div>
    <div class="mb-3 form-check" v-show="computedPrivileges.manageRetailers">
      <input type="checkbox" class="form-check-input" id="manage_retailers" v-model="userData.manageRetailers" />
      <label class="form-check-label" for="manage_retailers">{{ t(`${i18nScope}.columns.manage_retailers`) }}</label>
    </div>
    <div class="mb-3 form-check" v-show="computedPrivileges.manageRetailerAdmins">
      <input type="checkbox" class="form-check-input" id="manage_retailer_admins" v-model="userData.manageRetailerAdmins" />
      <label class="form-check-label" for="manage_retailer_admins">{{ t(`${i18nScope}.columns.manage_retailer_admins`) }}</label>
    </div>
    <div class="mb-3 form-check" v-show="computedPrivileges.manageLibraryAdmins">
      <input type="checkbox" class="form-check-input" id="manage_library_admins" v-model="userData.manageLibraryAdmins" />
      <label class="form-check-label" for="manage_library_admins">{{ t(`${i18nScope}.columns.manage_library_admins`) }}</label>
    </div>
  </form>
</template>